var BulkItemStatus = /* @__PURE__ */ ((BulkItemStatus2) => {
  BulkItemStatus2["Failed"] = "Failed";
  BulkItemStatus2["InProgress"] = "InProgress";
  BulkItemStatus2["Pending"] = "Pending";
  BulkItemStatus2["Successful"] = "Successful";
  BulkItemStatus2["PartiallySuccessful"] = "PartiallySuccessful";
  BulkItemStatus2["TimedOut"] = "TimedOut";
  BulkItemStatus2["Skipped"] = "Skipped";
  return BulkItemStatus2;
})(BulkItemStatus || {});
const bulkItemFailedStatues = [
  "Failed",
  "TimedOut"
  /* TimedOut */
];
var BulkActionKey = /* @__PURE__ */ ((BulkActionKey2) => {
  BulkActionKey2["AccountLock"] = "account_lock";
  BulkActionKey2["WithdrawalLock"] = "withdrawal_lock";
  BulkActionKey2["DepositLock"] = "deposit_lock";
  BulkActionKey2["LobbyLock"] = "lobby_lock";
  BulkActionKey2["CasinoLock"] = "CasinoLock";
  BulkActionKey2["SportsbookLock"] = "SportsbookLock";
  BulkActionKey2["SecurityCases"] = "security_cases";
  BulkActionKey2["SecurityCasesAdd"] = "security_cases_add";
  BulkActionKey2["SecurityCasesUpdate"] = "security_cases_update";
  BulkActionKey2["SecurityCasesRemove"] = "security_cases_remove";
  BulkActionKey2["SecurityCasesAll"] = "security_cases_all";
  BulkActionKey2["Message"] = "message";
  BulkActionKey2["NotesAndAttachments"] = "notes_attachments";
  BulkActionKey2["ManualTriggerMTTTicket"] = "ManualTriggerMTTTicket";
  BulkActionKey2["ManualTriggerDepositCashMatch"] = "ManualTriggerDepositCashMatch";
  BulkActionKey2["ManualTriggerDepositCashMatchAmount"] = "ManualTriggerDepositCashMatchAmount";
  BulkActionKey2["ManualTriggerDepositCashMatchCode"] = "ManualTriggerDepositCashMatchCode";
  BulkActionKey2["ManualTriggerImmediateCashBonus"] = "ManualTriggerImmediateCashBonus";
  BulkActionKey2["ManualTriggerCasinoCoinBonus"] = "ManualTriggerCasinoCoinBonus";
  BulkActionKey2["ManualTransactions"] = "ManualTransactions";
  BulkActionKey2["AddUserLabel"] = "AddUserLabel";
  BulkActionKey2["RemoveUserLabel"] = "RemoveUserLabel";
  BulkActionKey2["P2PTransfer"] = "P2PTransfer";
  BulkActionKey2["KYCReject"] = "KYCReject";
  BulkActionKey2["InitiatePaymentKYC"] = "InitiatePaymentKYC";
  BulkActionKey2["KYCAssign"] = "KYCAssign";
  BulkActionKey2["TransactionAssign"] = "TransactionAssign";
  BulkActionKey2["P2PSettings"] = "P2PSettings";
  BulkActionKey2["CreditReqeusts"] = "CreditRequests";
  BulkActionKey2["ManualCredit"] = "ManualCredit";
  return BulkActionKey2;
})(BulkActionKey || {});
const failedOperationId = "failedOperationId";
var BulkStatus = /* @__PURE__ */ ((BulkStatus2) => {
  BulkStatus2["Success"] = "Success";
  BulkStatus2["Warning"] = "Warning";
  return BulkStatus2;
})(BulkStatus || {});
export {
  BulkActionKey,
  BulkItemStatus,
  BulkStatus,
  bulkItemFailedStatues,
  failedOperationId
};
//# sourceMappingURL=types.js.map
